import cx from 'classnames';
import { twMerge } from 'tailwind-merge';
import { Heading } from 'components/Typography';
import { Icon, Props as IconProps } from 'components/Icon';

export type BadgeVariant = 'cream' | 'yellow' | 'green' | 'black' | 'orange' | 'blue';

export type BadgeProps = React.ComponentPropsWithRef<'div'> & {
  variant: BadgeVariant;
  icon?: IconProps['name'];
};

export const Badge = ({ variant, className, icon, children, ...rest }: BadgeProps) => (
  <Heading
    level="h8"
    className={twMerge(
      cx(
        'font-semibold',
        'flex items-center gap-4',
        'px-8 py-[1px] w-max rounded-full uppercase',
        {
          'bg-green-100 text-green-700': variant === 'green',
          'bg-yellow-100 text-yellow-900': variant === 'yellow',
          'bg-cream-100 text-cream-500': variant === 'cream',
          'bg-black-900 text-white': variant === 'black',
          'bg-orange-50 text-orange-800': variant === 'orange',
          'bg-blue-50 text-blue-700': variant === 'blue',
        },
        className,
      ),
    )}
    {...rest}
  >
    {icon && <Icon name={icon} className="w-16 h-16" />}
    {children}
  </Heading>
);
